
shadow.loader.init("");
fablo_offers.app.core.init();